import { KeyedResource } from './keyed.resource';

export class RelationResource extends KeyedResource {
  private relationNameImpl: string;

  constructor(args: any, relationName: string = undefined) {
    super(args, args.relationName);
    const self: any = this;
    self.resourceType = 'relation';
    self.relationNameImpl = this.uiResourceName;
  }

  public get relationName() {
    return this.relationNameImpl;
  }
}
